/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ChevronRightIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 9.333 16.326'>
			<path
				data-name='Icon ionic-ios-arrow-back'
				d='M6.519 8.165L.342 14.338a1.167 1.167 0 001.653 1.647l7-6.994a1.164 1.164 0 00.032-1.608L1.999.341A1.167 1.167 0 10.347 1.989z'
				fill={color}
			/>
		</svg>
	)
}

export default ChevronRightIcon
